var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPeople(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 8.33333C11.6108 8.33333 12.9167 7.0275 12.9167 5.41667C12.9167 3.80584 11.6108 2.5 10 2.5C8.38918 2.5 7.08334 3.80584 7.08334 5.41667C7.08334 7.0275 8.38918 8.33333 10 8.33333Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 17.0001V17.5001H17.5V17.0001C17.5 15.1332 17.5 14.1998 17.1367 13.4868C16.8171 12.8596 16.3072 12.3496 15.68 12.03C14.9669 11.6667 14.0335 11.6667 12.1667 11.6667H7.83333C5.9665 11.6667 5.03308 11.6667 4.32004 12.03C3.69283 12.3496 3.18289 12.8596 2.86331 13.4868C2.5 14.1998 2.5 15.1332 2.5 17.0001Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeople);
export default __webpack_public_path__ + "static/media/people.2749e7fab8dcc7e105ea4a1e85bf595f.svg";
export { ForwardRef as ReactComponent };